import defaultsDeep from 'lodash/defaultsDeep';
import { Options } from './axios-config';
import BaseConfig from './http.base-instance-config';
import { getRegionVariable } from '@white-label-helper/get-region-variable';

const { interceptors } = BaseConfig;
const baseURL = `${getRegionVariable('domains.cart')}/v1`;

interface CartInstance extends Options {
  baseURL: string | undefined;
}

const options: CartInstance = defaultsDeep(
  {
    baseURL,
  },
  BaseConfig.options,
);

export default {
  interceptors,
  options,
};
